import script from "./STK01_011INS.vue?vue&type=script&setup=true&lang=js"
export * from "./STK01_011INS.vue?vue&type=script&setup=true&lang=js"

import "./STK01_011INS.vue?vue&type=style&index=0&id=573c91c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-573c91c9"]])

export default __exports__